import { useSettings } from '@api/application-configuration';

export const useSettingValue = <T = string>(
  settingName: string,
  defaultValue?: T
): T | undefined => {
  const settings = useSettings();

  return settings ? ((settings[settingName] as T) ?? defaultValue) : defaultValue;
};
